import { StyleSheet } from 'react-native';
import {
  fontSizeExtraSmall,
  fontFamilyRegular,
} from '../../../constants/palette';

export default StyleSheet.create({
  text: {
    fontSize: fontSizeExtraSmall,
    fontFamily: fontFamilyRegular,
  },
});
